"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Asterisk;

var _Asterisk = require("@adobe/react-spectrum-ui/dist/Asterisk");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Asterisk(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_Asterisk.Asterisk, null));
}